
import { defineComponent } from 'vue';

/**
 * Icone de seta.
 * @displayName IconClose [Componente do UseIcon]
 */
export default defineComponent({
    name: 'IconClose',
    props: {
        size: {
            type: [String, Number],
            default: 22,
        },
        color: {
            type: String,
            default: 'white',
        },
    },
});
